import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import CustomerAskTheExpertJsx from './roleManage.jsx'

export default class AskTheExpert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            isLoading: false,
        }
    }

    // Handle add new role
    handleAddRole = () => {
        this.props.history.push("/admin/roleAdd");
    };

    // Handle edit role
    handleEditRole = (roleData) => {
        // Store the role data in localStorage or pass it through route state
        localStorage.setItem('editRoleData', JSON.stringify(roleData));
        this.props.history.push("/admin/roleEdit", { roleData });
    };

    // Handle delete role
    handleDeleteRole = (roleId) => {
        if (window.confirm('Are you sure you want to delete this role?')) {
            this.setState({ isLoading: true });
            let token = JSON.parse(localStorage.getItem('token'));
            
            axios.delete(`${baseURL}/role/${roleId}`, {
                headers: { 'x-access-token': token }
            }).then(res => {
                this.setState({ isLoading: false });
                toast.success('Role deleted successfully!');
                this.loadRoles(); // Reload the roles list
            }).catch(err => {
                this.setState({ isLoading: false });
                toast.error(err.response?.data?.error?.message || 'Failed to delete role');
            });
        }
    };

    // Load roles data
    loadRoles = () => {
        this.setState({ isLoading: true });
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/roles`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ 
                categoryData: res.data.data, 
                isLoading: false 
            });
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error('Failed to load roles');
        });
    };

    componentDidMount = () => {
        this.loadRoles();
    }

    render() {
        return (
            <div>
                <CustomerAskTheExpertJsx
                    categoryData={this.state.categoryData}
                    handleAddRole={this.handleAddRole}
                    handleEditRole={this.handleEditRole}
                    handleDeleteRole={this.handleDeleteRole}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}